import { FC } from 'react'
import { Edit, SimpleForm, TextInput } from 'react-admin'
import { ToolFormFields } from '../../components'

const ProxyToolEdit: FC = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextInput source="proxy_id" label="data.proxyId" fullWidth disabled />
      <ToolFormFields />
    </SimpleForm>
  </Edit>
)

export default ProxyToolEdit
